import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from 'components/Sidebar/components/MenuItem';
import { purgeItemType } from 'types';
import ProjectPurgeModal from './components/ProjectPurgeModal';

/* eslint-disable jsx-a11y/click-events-have-key-events,
   jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */

const SidebarPurge = ({
  getPurgeList,
  isOpen,
  isOpenPurgeModal,
  isLoading,
  isPurging,
  onCloseModal,
  purgeList,
  purgeProject,
  purgableDataAreEmpty,
  availablePurgableItemExists,
}) => (
  <React.Fragment>
    <MenuItem
      isOpen={isOpen}
      isTop
      item={{
        title: 'Recycle Bin',
        icon: 'recycle-bin',
      }}
      onClick={getPurgeList}
    />

    {isOpenPurgeModal && (
      <ProjectPurgeModal
        isOpen={isOpenPurgeModal}
        isLoading={isLoading}
        isPurging={isPurging}
        onCloseModal={onCloseModal}
        purgeList={purgeList}
        purgeProject={purgeProject}
        purgableDataAreEmpty={purgableDataAreEmpty}
        availablePurgableItemExists={availablePurgableItemExists}
      />
    )}
  </React.Fragment>
);

SidebarPurge.propTypes = {
  getPurgeList: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isOpenPurgeModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
  purgeProject: PropTypes.func,
  purgeList: PropTypes.shape(purgeItemType),
  isLoading: PropTypes.bool,
  isPurging: PropTypes.bool,
  purgableDataAreEmpty: PropTypes.bool,
  availablePurgableItemExists: PropTypes.bool,
};

export default SidebarPurge;
